import api from "../api/configAxios";
import Controller from "../common/controller";

export const getConfigurations = async (dynamoDBClient, config) => {
  try {
    const params = {
      TableName: "Configurations",
      FilterExpression: "ModeType = :id",
      ExpressionAttributeValues: {
        ":id": config,
      },
    };
    const data = await dynamoDBClient.scan(params).promise();

    return data.Items;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTosConfigurations = async (access_token) => {
  try {
    var response = await api.get(`${Controller.dynamoDB}/TermOfServiceList`, {
      headers: {
        Authorization: "Bearer " + access_token,
      },
    });
    let data = response.data;
    data = data.sort(
      (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
    );

    return data;
  } catch (error) {
    throw error;
  }
};
